import { Box } from '@mui/material';
import { images } from '../../../../shared/lib/assets';
import { AuthLogoBox } from '../../../../shared/lib/theme/styleComponents';
import { BRAND_NAME_FULL } from '../../../../shared/lib/constants';

export const AuthLogo = () => (
  <AuthLogoBox>
    <Box component="img" src={images.MOBILE_AUTH_LOGO as unknown as string} alt="Who Do I Call Logo" sx={{ height: '165px' }} />

    <Box component="img" src={images.WDIC_TITLE_LOGO as unknown as string} alt={BRAND_NAME_FULL} sx={{ width: '250px', marginTop: '20px' }} />
  </AuthLogoBox>
);
